import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import MainTitle from 'base/components/MainTitle/index';
import FieldWrapper from 'base/components/forms/FieldWrapper';
import Title3 from 'base/components/Title3/index';
import { deleteSpace } from 'spaces/store/actions';
import { getActiveSpace } from 'spaces/store/selectors';
import { closeModal } from 'modal/store/actions';
import Button from 'base/components/Button/index';
import Col from 'base/components/Col/index';
import Row from 'base/components/Row/index';

const CreateFolderModal = ({
  name, closeModal, space, deleteSpace,
}) => (
  <>
    <MainTitle withSpaceBelow>Delete Space</MainTitle>

    <FieldWrapper>
        Do you really want to delete
      <Title3>{space && space.name}</Title3>
    </FieldWrapper>

    <FieldWrapper>
        This will also delete all its folders and files.
    </FieldWrapper>

    <Row>
      <Col>
        <Button isFullWidth variant="secondary" onClick={() => closeModal(name)}>No, cancel</Button>
      </Col>
      <Col>
        <Button
          isFullWidth
          variant="primary"
          onClick={() => { closeModal(name); deleteSpace(space); }}
        >
            Yes, delete
        </Button>
      </Col>
    </Row>
  </>
);
CreateFolderModal.propTypes = {
  name: PropTypes.string.isRequired,
  space: PropTypes.object.isRequired, // eslint-disable-line
  closeModal: PropTypes.func.isRequired,
  deleteSpace: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  space: getActiveSpace(state),
});

const mapDispatchToProps = {
  deleteSpace,
  closeModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CreateFolderModal);
